import React, { useState, useEffect } from 'react';
import style from './style.module.css'
import { Link } from 'react-router-dom';

import Icons from '../Icons/Icons';
import { faBook, faSquareCheck, faCircleHalfStroke, faBan, faLock, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { 
    inProgress, unavailable, locked, urlAcademy, Language, getLanguageArray, outOfLabel, 
    modulesCompletedLabel, inProgressLabel, totalLabel, continueLearningLabel, systemLanguage 
} from '../../utils/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sysLabels } from '../../data/translations';

import tin from './assets/badges/tin.png';
import bronze from './assets/badges/bronze.png';
import silver from './assets/badges/silver.png';
import gold from './assets/badges/gold.png';
import sapphire from './assets/badges/sapphire.png';
import ruby from './assets/badges/ruby.png';
import diamond from './assets/badges/diamond.png';
import emerald from './assets/badges/emerald.png';
import obisidian from './assets/badges/obisidian.png';
import mythril from './assets/badges/mythril.png';
import iron from './assets/badges/iron.png';
import phishnoonite from './assets/badges/phishnoonite.png';

interface ProgressItem {
    status: 'in_progress' | 'complete' | 'unavailable' | 'locked';
    label: string;
    link: string;
}

interface ChapterBlockProps {
    num?: number,
    summary?: Boolean,
    content: string,
    statusIcon: string,
    progress: ProgressItem[],
    totalNumber: number | 0,
    pagination?: Boolean,
    backButton?: React.ReactNode;
    forwardButton?: React.ReactNode;
}

const ChapterBlock: React.FC<ChapterBlockProps> = ({
    num = 0, summary = false, content, progress, statusIcon, totalNumber, 
    pagination = false, backButton = null, forwardButton = null
}) => {

    let progressIcons = {
        'in_progress': <div className={style.inProgress}><Icons icon={faCircleHalfStroke} /></div>, 
        'complete': <div className={style.complete}><Icons icon={faSquareCheck} /></div>,
        'unavailable' : <div className={style.unavailable}><Icons icon={faBan} /></div>,
        'locked' : <div className={style.locked}><Icons icon={faLock} /></div>
    };

    const chapterBadges: Record<number, string> = {
        0: tin,
        1: bronze,
        2: silver,
        3: gold,
        4: sapphire,
        5: ruby,
        6: diamond,
        7: emerald,
        8: obisidian,
        9: mythril,
        10: iron,
        11: phishnoonite,
    };

    const { totalModules, completedModules, progressModules } = progress.reduce(
        (acc, module) => {
          acc.totalModules++;
          if (module.status === "complete") {
            acc.completedModules++;
          }
          if(module.status === "in_progress"){
            acc.progressModules++;
          }
          return acc;
        },
        { totalModules: 0, completedModules: 0, progressModules: 0 }
    );
      
    const completedPercentage = totalNumber > 0
        ? Math.round((completedModules / totalNumber) * 100)
        : 0;

    const lastItemLink = [...progress]
        .reverse()
        .find((item) => item.status !== 'unavailable')?.link;

    const [sessionLang,setSessionLang] = useState<Language>(getLanguageArray());
    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
              setSessionLang(JSON.parse(e.newValue));
            }
          };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    return (<>
        <div className={`${style.chapter} ${statusIcon === unavailable ? style.unavailable : ''} ${
                statusIcon === inProgress ? style.in_progress : 
                statusIcon === unavailable ? style.unavailable : 
                statusIcon === locked ? style.locked_module : ''
            }`}>
            <div className={`${style.chapterBadge} ${summary ? style.summary : ''}`}>
                <div className={style.title}>
                    <div className={style.status}>
                    {
                            statusIcon === inProgress ? 
                                <div className={style.inProgress}>
                                    <Icons icon={faCircleHalfStroke} />
                                </div> :
                            statusIcon === unavailable ?
                                <div className={style.unavailable}>
                                    <Icons icon={faBan} />
                                </div> :
                            statusIcon === locked ?
                                 <div className={style.locked}>
                                    <Icons icon={faLock} />
                                </div>
                                :
                                <div className={style.complete}>
                                    <Icons icon={faSquareCheck} />
                                </div>
                        }
                    </div>
                </div>
                <div className={style.paginationWrapper}>
                    {pagination && backButton ? <div className={style.arrowLeftWrapper}>{backButton}</div> : pagination && <div className={style.defaultSpace}></div>} 
                    <img src={chapterBadges[num]} alt={`Chapter ${num}`} />
                    {pagination && forwardButton ? <div className={style.arrowRightWrapper}>{forwardButton}</div> : pagination && <div className={style.defaultSpace}></div>}
                </div>
            </div><div className={`${style.chapterData} ${summary ? style.summary : ''}`}>
                <div className={style.title}>
                    <Icons icon={faBook} /><span>{content}</span><div className={`${style.status} ${!summary? style.hide : ''}`}>
                    {
                            statusIcon === inProgress ? 
                                <div className={style.inProgress}>
                                    <Icons icon={faCircleHalfStroke} />
                                </div> :
                            statusIcon === unavailable ?
                                <div className={style.unavailable}>
                                    <Icons icon={faBan} />
                                </div>
                                :
                                <div className={style.complete}>
                                    <Icons icon={faSquareCheck} />
                                </div>
                        }
                    </div>
                </div>
                <div className={style.progressSection}>
                    {
                        progress.map((item) => (
                            <div className={`${style.progress} ${item.status === unavailable ? style.hidden : item.status === locked ? style.locked : ''}`} >
                                {
                                    item.status === unavailable || item.status === locked ?
                                        <>{progressIcons[item.status]}<span>{item.label}</span></> 
                                    :
                                    <Link to={urlAcademy+item.link}>{progressIcons[item.status]}<span>{item.label}</span></Link>
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    completedModules !== totalModules && statusIcon !== unavailable && statusIcon !== locked ? <>
                        <div className={style.continue}>
                            <Link to={urlAcademy+lastItemLink}>{sysLabels[continueLearningLabel][((sessionLang as unknown) as Language).short || 'EN']}<span><FontAwesomeIcon icon={faArrowRight} /></span></Link>
                        </div>
                    </> : ''
                }
                <div className={style.chart}>
                    <div className={style.summary}>
                        {
                            completedModules === totalModules ? 
                                <>
                                    {completedModules} {sysLabels[outOfLabel][((sessionLang as unknown) as Language).short || 'EN']} {totalModules} {sysLabels[modulesCompletedLabel][((sessionLang as unknown) as Language).short || 'EN']}.
                                </> :
                                <>
                                    {completedModules} {sysLabels[modulesCompletedLabel][((sessionLang as unknown) as Language).short || 'EN']}, {progressModules} {sysLabels[inProgressLabel][((sessionLang as unknown) as Language).short || 'EN']}, {totalNumber} {sysLabels[totalLabel][((sessionLang as unknown) as Language).short || 'EN']}.
                                </>
                        }
                    </div>
                    <div className={style.bar}>
                        <div
                            className={style.completed}
                            style={{ width: `${completedPercentage}%` }}
                            ></div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ChapterBlock;